var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDataFromStorage } from "../../libs/auth.helper";
import AppConfig from "../../app-config";
export default (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const storage = getDataFromStorage();
    const userId = ((_a = storage.userInfo) === null || _a === void 0 ? void 0 : _a.id) || '';
    const lang = AppConfig.getConfig().lang;
    const token = yield AppConfig.getConfig().actions.getToken();
    config.headers['Content-Type'] = 'application/json';
    config.headers['source'] = storage.source;
    config.headers['country'] = storage.country;
    config.headers['session-id'] = userId;
    config.headers['X-Tracking-UUID'] = String(userId);
    config.headers['Authorization'] = "Bearer " + token;
    config.headers['accept-language'] = config.headers["accept-language"] || lang;
    config.headers['enforce-language'] = config.headers["accept-language"] || lang;
    return config;
});
